const checkRowActions = ({ row, action }) => {
	return row.rowButtons.includes(action.name.toLowerCase());
};

export default checkRowActions;
